import { ls } from "@/utils/cache";
import { ISIFRAME } from "@/store/mutation-types";
import { asyncRoutes, constantRoutes } from "@/router/router.config";

function hasPermission(permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = false;
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i].code);
      if (flag) {
        return permission[i];
      }
    }
    return false;
  }
  return true;
}

function filterAsyncRouter(routerMap, roles) {
  const accessedRouters = routerMap.filter(route => {
    const res = hasPermission(roles, route);
    if (res === true) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles);
      }
      return true;
    } else if (res !== false) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, res.children);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}

const app = {
  namespaced: true,
  state: {
    deleteRouter: "", //需要删除的路由  缓存时使用
    navActive: "", //底部选中路由name
    menus: [], //菜单
    routers: [], //路由
    addRouters: [], //权限控制路由
    pageKeepAlive: [] //缓存页面
  },
  mutations: {
    SET_MENUS: (state, routers) => {
      state.menus = routers;
      state.routers = constantRoutes.concat(routers);
    },
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
    },
    SET_ADDROUTERS: (state, addRouters) => {
      state.addRouters = addRouters;
    },
    SET_NAVACTIVE: (state, name) => {
      state.navActive = name;
    },
    SET_PAGEKEEPALIVE: (state, data) => {
      state.pageKeepAlive = data;
    },
    SET_PAGEKEEPALIVEPUSH: (state, data) => {
      if (!state.pageKeepAlive.includes(data)) {
        state.pageKeepAlive.push(data);
      }
    },
    DELETE_PAGEKEEPALIVE: (state, data) => {
      let index = state.pageKeepAlive.findIndex(p => p === data);
      if (index > -1) {
        state.deleteRouter = data;
        state.pageKeepAlive.splice(index, 1);
      }
    },
    SET_DELETEROUTER: (state, data) => {
      state.deleteRouter = data;
    },
    SET_ISIFRAME: (state, data) => {
      ls.set(ISIFRAME, data, 24 * 3600 * 1000);
      state.isIframe = data;
    }
  },
  actions: {
    setMenus({ commit }, data) {
      commit("SET_MENUS", data);
    },
    generateRoutes({ commit }, data) {
      return new Promise(resolve => {
        // const { roles } = data;
        const accessedRouters = filterAsyncRouter(asyncRoutes, data);
        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    },
    setAddRouters({ commit }, data) {
      commit("SET_ADDROUTERS", data);
    },
    setNavActive({ commit }, name) {
      commit("SET_NAVACTIVE", name);
    },
    setPageKeepAlive({ commit }, data) {
      commit("SET_PAGEKEEPALIVE", data);
    },
    setPageKeepAlivePush({ commit }, data) {
      commit("SET_PAGEKEEPALIVEPUSH", data);
    },
    deletePageKeepAlive({ commit }, data) {
      commit("DELETE_PAGEKEEPALIVE", data);
    },
    setDeleteRouter({ commit }, data) {
      commit("DELETE_PAGEKEEPALIVE", data);
    },
    setIsIframe({ commit }, data) {
      commit("SET_ISIFRAME", data);
    }
  }
};

export default app;
